import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import s from '../Themes.module.css';
import { useAuth } from '../context/AuthContext';
import { useAppTranslation } from "./TranslationContext";

export const Themes = () => {
  const { id } = useParams();
  const { user, handleLang } = useAuth();
  const { t } = useAppTranslation();

  const [themes, setThemes] = useState([]);
  const [kursNameUz, setKursNameUz] = useState('');
  const [kursNameRu, setKursNameRu] = useState('');
  const [kursNameEn, setKursNameEn] = useState('');
  const [kursImg, setKursImg] = useState('');
  const [loadingThemes, setLoadingThemes] = useState(true);
  const [errorThemes, setErrorThemes] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [userKurs, setUserKurs] = useState(null);

  // --- Получение данных курса ---
  useEffect(() => {
    if (!id) return;
    const loadCourseInfo = async () => {
      try {
        const res = await fetch(`https://api.rasulova-academy.uz/api/kurslar/${id}/`);
        if (!res.ok) throw new Error(`Ошибка получения курса: ${res.status}`);
        const data = await res.json();
        setKursNameUz(data.nomi_uz);
        setKursNameRu(data.nomi_ru);
        setKursNameEn(data.nomi_en);
        setKursImg(data.img_uz);
      } catch (err) {
        console.error("Ошибка загрузки курса:", err);
      }
    };
    loadCourseInfo();
  }, [id]);

  // --- КЕШИРОВАННАЯ загрузка тем ---
  useEffect(() => {
    if (!id) return;

    const cacheKey = `kurs_themes_cache_${id}`;
    const cache = localStorage.getItem(cacheKey);

    if (cache) {
      try {
        const parsed = JSON.parse(cache);
        const now = Date.now();
        const weekMs = 7 * 24 * 60 * 60 * 1000;
        if (now - parsed.timestamp < weekMs) {
          setThemes(parsed.data);
          setLoadingThemes(false);
          return;
        }
      } catch {}
    }

    const loadThemes = async () => {
      try {
        setLoadingThemes(true);
        const res = await fetch(`https://api.rasulova-academy.uz/api/kurs-mavzulari/?kurs=${id}`);
        if (!res.ok) throw new Error("Ошибка сети: " + res.status);

        const json = await res.json();
        const sorted = json
          .map(i => ({
            tartib: i.tartib,
            id: i.id,
            kurs_id: id,
            title_uz: i.nomi_uz,
            title_ru: i.nomi_ru,
            title_en: i.nomi_en,
            image: i.mrasmi_uz,
            desc_uz: i.short_text_uz,
            desc_ru: i.short_text_ru,
            desc_en: i.short_text_en,
            test_soni: i.test_soni,
            test_min: i.test_min_soni,
            test_description_uz: i.test_description_uz,
            test_description_ru: i.test_description_ru,
            test_description_en: i.test_description_en
          }))
          .sort((a, b) => a.tartib - b.tartib);

        setThemes(sorted);

        localStorage.setItem(cacheKey, JSON.stringify({
          timestamp: Date.now(),
          data: sorted
        }));

      } catch (err) {
        setErrorThemes(err.message);
      } finally {
        setLoadingThemes(false);
      }
    };

    loadThemes();
  }, [id]);

  // --- загрузка user-kurs ---
  useEffect(() => {
    const fetchUserKurs = async () => {
      try {
        const token = localStorage.getItem('token');
        const userId = user?.id;
        if (!token || !userId) return;

        const res = await fetch(`https://api.rasulova-academy.uz/api/user-kurs/?user=${userId}&kurs=${id}`, {
          headers: { 'Authorization': `Token ${token}` }
        });

        if (!res.ok) throw new Error('Ошибка при получении user-kurs');
        const data = await res.json();
        setUserKurs(data?.[0]);
      } catch (error) {
        console.error("Ошибка сети:", error);
      }
    };

    fetchUserKurs();
  }, [user, id]);

  const toggle = (index) => setOpenIndex(openIndex === index ? null : index);

  if (errorThemes) return <p>Ошибка загрузки тем: {errorThemes}</p>;
  if (loadingThemes || !userKurs) return <p className='container'>Ma'lumotlar yuklanmoqda...</p>;

  const completed = userKurs.mavzu;

  return (
    <section className={s.course__intro}>
      <div className={s.c__intro__sidebar}>
        <div className={s.c__intro__sidebar_info}>
          <div className={s.c__intro__sidebar_title}>
            {handleLang(kursNameUz, kursNameRu, kursNameEn)}
          </div>
          <div className={s.c__intro__sidebar_num}>
            {completed <= themes.length ? completed : themes.length}/{themes.length} {t('themes')}
          </div>
          <img src={kursImg} alt="Картинка курса" className={s.c__intro__sidebar_img} />
        </div>
      </div>

      <div className={s.c__intro__content}>
        {themes.map((item, index) => {
          const isAccessible = item.tartib <= completed;
          return (
            <div key={index} className={s.accordion_item}>
              <div className={s.accordion_header} onClick={() => toggle(index)}>
                {handleLang(item.title_uz, item.title_ru, item.title_en)}
                <span className={`${s.arrow} ${openIndex === index ? s.open : ''}`}>▶</span>
              </div>

              <div className={`${s.accordion_content} ${openIndex === index ? s.open : ''}`}>
                {isAccessible ? (
                  <Link className={s.sub_item} to={`/Lesson/${id}/${item.id}`}>
                    <img src={item.image} className={s.video_thumb} alt="Видео превью" />
                    <p>{handleLang(item.desc_uz, item.desc_ru, item.desc_en)}</p>
                  </Link>
                ) : (
                  <div className={s.sub_item} style={{ pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' }}>
                    <img src={item.image} className={s.video_thumb} alt="Нет доступа" />
                    <p>{handleLang(item.desc_uz, item.desc_ru, item.desc_en)}</p>
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {themes.length + 1 === completed ? (
          <Link className={s.sub_item} to={`/Yakuniy/${id}/`}>
            <div className={`${s.accordion_item} ${s.yakuniy}`}>
              <div className={s.accordion_header}>
                {t('themesFin')} <span className={s.arrow}>▶</span>
              </div>
            </div>
          </Link>
        ) : (
          <div className={s.sub_item} style={{ pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' }}>
            <div className={`${s.accordion_item} ${s.yakuniy}`}>
              <div className={s.accordion_header}>
                {t('themesFin')} <span className={s.arrow}>▶</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
